import React from "react";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import { useNavigate } from "react-router";
import "./chart.css";

const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return (
    <span style={{ color }} className="barChartLegend">
      {value}
    </span>
  );
};

const RenderLegend = (props) => {
  const navigate = useNavigate();
  const { payload } = props;

  return (
    <div className="poll_survey_barChart_legend_main_box">
      <div className="poll_survey_barChart_legend_title">{props.title}</div>
      <div className="poll_survey_barChart_legend_box">
        {payload.map((entry, index) => (
          <div
            key={`item-${index}`}
            className="poll_survey_barChart_legend_box_item"
          >
            <div
              className="poll_survey_barChart_legend_box_item_dot"
              style={{ backgroundColor: entry.color }}
            />
            {props.external.find((i) => i.data_key === entry.dataKey)
              ? props.external.find((i) => i.data_key === entry.dataKey).title
              : entry.value}
          </div>
        ))}
      </div>
    </div>
  );
};

const RenderTooltip = ({ active, payload, external }) => {
  if (active && payload && payload.length) {
    const item = payload[0];
    return (
      <div className="barchart_tooltip_main_box">
        <div className="barchart_tooltip_text">
          {`${payload[0]?.payload?.percent}%`}
        </div>
        <div className="barchart_tooltip_text">
          {external.find((j) => j.data_key === item.dataKey)
            ? external.find((j) => j.data_key === item.dataKey).title
            : item.name}
          : {item.value}
        </div>
      </div>
    );
  }
  return null;
};

export const PollSurveyDonutChartComponents = ({ data, config }) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <PieChart>
        <Pie
          data={data}
          dataKey="count"
          nameKey="value"
          cx="50%"
          cy="50%"
          innerRadius={50}
          outerRadius={90}
        >
          {data.map((entry, index) => (
            <Cell key={`cell-${index}`} fill={entry.color} />
          ))}
        </Pie>
        <Tooltip
          content={
            <RenderTooltip
              external={config?.config || []}
            />
          }
        />
        <Legend
          content={
            <RenderLegend
              external={config?.config || []}
              isShowLegend={config?.legend}
              type={config?.legend_type}
              title={config?.graph_title}
            />
          }
          verticalAlign="top"
          align="right"
          iconType="circle"
          formatter={renderColorfulLegendText}
        />
      </PieChart>
    </ResponsiveContainer>
  );
};
